'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.metaWithAssetId = exports.updateMetaTags = exports.setTargetWindowObject = undefined;

var _ramda = require('ramda');

var MetaTagService = {
  setTargetWindowObject: function setTargetWindowObject(targetWindowObject) {
    this.targetWindowObject = targetWindowObject;
  },
  updateMetaTags: function updateMetaTags(metaObj) {
    if (!(0, _ramda.isNil)(this.metaWithAssetId('assetType')) && this.metaWithAssetId('assetType').getAttribute('content') !== 'Product') {
      var title = this.targetWindowObject.document.title;
      if (!(0, _ramda.isNil)(this.metaWithAssetId('assetID'))) {
        this.metaWithAssetId('assetID').setAttribute('content', metaObj.meta.name.assetID);
      }
      if (!(0, _ramda.isNil)(this.metaWithAssetId('assetType'))) {
        this.metaWithAssetId('assetType').setAttribute('content', metaObj.meta.name.assetType);
      }
      if (!(0, _ramda.isNil)(this.metaWithAssetId('keywords'))) {
        this.metaWithAssetId('keywords').setAttribute('content', metaObj.meta.name.keywords);
      }
      if (title.indexOf("-") > -1) {
        this.targetWindowObject.document.title = metaObj.title + title.substring(title.indexOf("-"));
      }
    }
  },
  metaWithAssetId: function metaWithAssetId(metaTagName) {
    return [].slice.call(this.targetWindowObject.document.getElementsByTagName('meta')).filter(function (e) {
      return e.getAttribute('name') === metaTagName;
    })[0];
  }
};

exports.default = MetaTagService;
var setTargetWindowObject = MetaTagService.setTargetWindowObject,
    updateMetaTags = MetaTagService.updateMetaTags,
    metaWithAssetId = MetaTagService.metaWithAssetId;
exports.setTargetWindowObject = setTargetWindowObject;
exports.updateMetaTags = updateMetaTags;
exports.metaWithAssetId = metaWithAssetId;